import { scrollTo } from '@/utils/scrollTo'
const scrolltop = {}
scrolltop.install = Vue => {
  Vue.directive('scrolltop', {
    bind(el, binding) {
      let mtinput = el.querySelector('textarea') || el.querySelector('input')
      mtinput.onblur = () => {
        scrollTo(0, 800)
      }
    },
    unbind() {
    }
  })
}

export default scrolltop

